/* ============================================================================
   Ullavi local <sticky-atc> controller — restores ONLY the sticky Add-to-Cart
   bar behaviour that lived in the removed remote Shrine bundle
   (https://js.shrinetheme.com/js/v2/main.js). NO external calls, self-contained.

   The theme ships component-sticky-atc.css with a fixed bottom bar HIDDEN via
   `.sticky-atc--after-scroll { transform: translateY(100%) }` and revealed via
   `.sticky-atc--after-scroll.sticky-atc--active` (btnAppear -> translateY(0)).
   The remote bundle added `--after-scroll` on load, toggled `--active` on scroll,
   and submitted the product form named in the sticky button's `form=` attribute.
   With the bundle gone the element was unhandled: the fixed bar (and its payment
   badges) stayed stuck visible, and the button did nothing. This re-implements it.

   IMPORTANT: the sticky button carries `form="product-form-<id>__main"`. We submit
   THAT specific form. Do NOT click a generic `.product-form__submit` — the free-gift
   widget has its own `.product-form__submit` earlier in the DOM, so a first-match
   click adds the $0 gift instead of the product.

   Fail-safe: the bar is set to the HIDDEN state on init, so if the target is ever
   missing the bar simply stays hidden — it never floats.
   ============================================================================ */
(function () {
  if (window.__ullaviStickyAtc) return; window.__ullaviStickyAtc = true;

  function initBar(bar) {
    if (bar.__cpInit) return; bar.__cpInit = true;
    // Start hidden (slid off-screen) — matches the remote bundle's on-load state.
    bar.classList.add('sticky-atc--after-scroll');

    var stickyBtn = bar.querySelector('.sticky-atc__add_button, [id^="SectionAtcBtn"], button');
    // The exact product form this bar belongs to (its own button tells us which one).
    var formId = stickyBtn && stickyBtn.getAttribute('form');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) { form = document.querySelector('.main-product-form form, form.main-product-form'); }

    // Reveal-tracking target = THIS form's main Add-to-Cart button (not a generic match).
    var mainAtc = (form && form.querySelector('[type="submit"], [name="add"]')) ||
      document.querySelector('.main-product-form [type="submit"], [id^="ProductSubmitButton"]');
    if (!mainAtc) return; // stays hidden -> never floats

    var raf = null;
    function apply() {
      raf = null;
      var r = mainAtc.getBoundingClientRect();
      // reveal once the main ATC has scrolled up past the top of the viewport
      bar.classList.toggle('sticky-atc--active', r.bottom <= 0);
    }
    function onScroll() { if (raf == null) raf = requestAnimationFrame(apply); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();

    // NOTE: the sticky button's click->add + loading state is handled by the delegated
    // `.main-product-atc` handler in cart-local.js (which also covers the in-content
    // "Add ... To Cart" CTAs). This controller only owns the show/hide-on-scroll behaviour.
  }

  function init() {
    var bars = document.querySelectorAll('sticky-atc');
    for (var i = 0; i < bars.length; i++) initBar(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
